/**
 *
 * Asynchronously loads the component for Stepper
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Stepper = lazyLoad(
  () => import('./index'),
  module => module.Stepper,
);
